export default "__VITE_ASSET__CNnT0Qqp__"